import { Badge } from "@/components/ui/badge";
import { PhoneOff } from "lucide-react";

/**
 * Marks a number on the do-not-call list, or a call where the person asked not to be called again
 * (requested). Settings -> Do-not-call manages the list.
 * - default: listed for the whole organization; no agent calls it.
 * - thisAgent: listed for the agent of the call it sits on; other agents still can.
 * - agents: listed for that many agents only (where there is no single agent, e.g. a lead).
 */
export function DoNotCallBadge({
  requested = false,
  thisAgent = false,
  agents = 0,
}: {
  requested?: boolean;
  thisAgent?: boolean;
  agents?: number;
}) {
  const [label, title] = requested
    ? ["Do not call", "The person asked on this call not to be called again"]
    : thisAgent
      ? ["Do not call · this agent", "On this agent's do-not-call list: this agent's calls to the number are refused, other agents can still call"]
      : agents > 0
        ? [
            `Do not call · ${agents} ${agents === 1 ? "agent" : "agents"}`,
            `On the do-not-call list of ${agents} ${agents === 1 ? "agent" : "agents"}: those agents' calls are refused, other agents can still call`,
          ]
        : ["Do not call", "On the organization's do-not-call list: calls to this number are refused"];
  return (
    <Badge variant="outline" className="gap-1 border-danger/40 text-danger text-[10px] px-1.5 py-0 font-medium" title={title}>
      <PhoneOff className="h-3 w-3" />
      {label}
    </Badge>
  );
}
